import React from 'react';
import AlertFormInitializer from '../components/AlertForm/AlertFormInitializer';
import CreateAlertPageStyleLoader from './CreateAlertPageStyleLoader';

function CreateAlertPage() {
  return (
    <CreateAlertPageStyleLoader>
      <div className="create-alert-page">
        {/* The AlertFormInitializer will render the form which includes its own title logic via hideTitle */}
        <AlertFormInitializer hideTitle={false} />
      </div>
    </CreateAlertPageStyleLoader>
  );
}

export default CreateAlertPage;
